import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Modal,
  Box,
  CircularProgress
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import Select from "react-select";
import { fetchallcitylist, fetchchapterbyuser } from "src/utils/common";
import { RemoveRedEye } from "@mui/icons-material";
import {
  GetMeetingByChptId,
  getMeetingFeedbackForList,
  getMeetingFeedbackReport,
  GetMemberByChptId,
  getMemberFeedbackAttachment,
  readMemberFeedbackApi
} from "src/api/commonapi";
import { CSVLink } from "react-csv";
import DataTable from "react-data-table-component";
import { Routes } from "src/constant/api_url";
import Label from "src/components/Label";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function MeetingFeedbackReport() {
  const feedbackAttachmentModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const { state } = useLocation();

  const [chaptlist, setchaplist] = useState([]);
  const [citylist, setcitylist] = useState([]);
  const [meetingFeedbackFor, setMeetingFeedbackFor] = useState([]);
  const [meetingData, setMeetingData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [newTableData, setNewTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchdata, setsearchdata] = useState({
    city_id:
      loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : state?.city || 0,
    chpt_id: 0,
    meeting_id: 0,
    m_id: 0,
    feedbackFor: 0,
    ratings: 0,
    mf_read: state?.mf_read ?? -1
  });

  const memberRatings = [
    { label: "All", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 }
  ];

  const feedbackType = [
    { label: "All", value: -1 },
    { label: "Read", value: 1 },
    { label: "Un Read", value: 0 }
  ];

  const [memberData, setMemberData] = useState([]);
  const getmemberbychp = async (ch_id) => {
    setMemberData(await GetMemberByChptId(ch_id));
  };

  const getMeetingFeedbackForData = async () => {
    let res = await getMeetingFeedbackForList();
    setMeetingFeedbackFor(res);
  };

  const readMemberFeedback = async (mf_id) => {
    setIsLoading(true);
    let res = await readMemberFeedbackApi({ mf_id });
    setIsLoading(false);

    if (res.status == 1) getMeetingFeedbackReportData();
  };

  const filterData = () => {
    let selectedCityChapter = chaptlist
      ?.map((chpt) => {
        if (searchdata?.city_id !== 0) {
          if (chpt?.city_id == searchdata?.city_id) {
            return chpt.chpt_id;
          }
        } else {
          return chpt.chpt_id;
        }
      })
      .filter((f) => f != undefined);

    const FeedbackList = tableData?.filter((feedback) => {
      return (
        (searchdata.chpt_id === 0 || feedback.chpt_id === searchdata.chpt_id) &&
        selectedCityChapter.includes(feedback.chpt_id) &&
        (searchdata.meeting_id === 0 || feedback.meeting_id === searchdata.meeting_id) &&
        (searchdata.m_id === 0 || feedback.m_id === searchdata.m_id) &&
        (searchdata.feedbackFor === 0 || feedback.mf_for === searchdata.feedbackFor) &&
        (searchdata.ratings === 0 || parseInt(feedback.mf_rate) === parseInt(searchdata.ratings)) &&
        (searchdata.mf_read === -1 || feedback.mf_read === searchdata.mf_read)
      );
    });

    setNewTableData(FeedbackList);
  };

  const isFilterApplied = () => {
    return (
      searchdata.city_id !== 0 ||
      searchdata.chpt_id !== 0 ||
      searchdata.meeting_id !== 0 ||
      searchdata.m_id !== 0 ||
      searchdata.feedbackFor !== 0 ||
      searchdata.ratings !== 0 ||
      searchdata.mf_read !== -1
    );
  };

  useEffect(() => {
    // if (!isFilterApplied()) {
    //   // Show only 1 month data on load
    //   const oneMonthAgo = new Date();
    //   oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    //   const filtered = tableData.filter((item) => {
    //     const timestamp = new Date(item.timestamp);
    //     return timestamp >= oneMonthAgo;
    //   });
    //   setNewTableData(filtered);
    // } else {
    filterData(); // Apply filters on all data
    // }
  }, [searchdata, tableData]);

  const ClearSearchResult = async () => {
    setsearchdata({
      city_id:
        loginUser?.u_type == 1 ||
          (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      chpt_id: 0,
      meeting_id: 0,
      m_id: 0,
      feedbackFor: 0,
      ratings: 0,
      mf_read: -1
    });
    setMemberData([]);
    setMeetingData([]);
  };

  const renderStars = (rating) => {
    const maxStars = 5;
    const filledStars = "★".repeat(Math.round(rating)); // Filled stars
    const emptyStars = "☆".repeat(maxStars - Math.round(rating)); // Empty stars

    return <span style={{ color: "gold", fontSize: "16px" }}>{filledStars + emptyStars}</span>;
  };

  const expo_columns = [
    { label: "No", key: "mf_id" },
    { label: "Meeting date", key: "date" },
    { label: "Member Name", key: "m_name" },
    { label: "Chapter Name", key: "chpt_name" },
    { label: "Rating", key: "mf_rate" },
    { label: "Feedback For", key: "meeting_feedback_for" },
    { label: "Description", key: "mf_desc" },
    { label: "Attachment Links", key: "attachment_links" }
  ];

  const columns = [
    {
      name: "No",
      selector: (row) => row.mf_id,
      wrap: true,
      sortable: true,
      width: "100px"
    },
    {
      name: "Meeting Date",
      wrap: true,
      selector: (row) => row.date,
      sortable: true,
      width: "110px",
      headCellStyle: {
        overflow: 'visible',
        whiteSpace: 'normal',
        textOverflow: 'unset'
      }
    },
    {
      name: "Feedback Date",
      wrap: true,
      selector: (row) => row.feedback_date,
      sortable: true,
      width: "110px",
      headCellStyle: {
        overflow: 'visible',
        whiteSpace: 'normal',
        textOverflow: 'unset'
      }
    },
    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row.m_name,
      sortable: true,
      width: "200px"
    },
    {
      name: "Chapter",
      wrap: true,
      selector: (row) => row.chpt_name,
      sortable: true,
      width: "150px"
    },
    {
      name: "Rating",
      selector: (row) => renderStars(row?.mf_rate), // Unicode-based stars
      sortable: true,
      width: "120px"
    },
    {
      name: "Feedback For",
      selector: (row) => row?.meeting_feedback_for,
      sortable: true,
      width: "180px"
    },
    {
      name: "Images",
      width: "130px",
      cell: (row) => (
        <>
          {row.has_attachment && row.has_attachment > 0 ? (
            <Tooltip title="View Attachment">
              <IconButton onClick={() => openModalWithAttachment(row.mf_id)}>
                <RemoveRedEye color="info" />
              </IconButton>
            </Tooltip>
          ) : (
            <Label variant={"ghost"} color="info">
              No Attachment
            </Label>
          )}
        </>
      )
    }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <div
        style={{
          padding: "5px 15px",
          backgroundColor: "#f3f3f39c",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <p style={{ margin: 0 }}>
          <b>Description</b> : {data?.mf_desc}
        </p>

        {data?.mf_read == 0 && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              readMemberFeedback(data?.mf_id);
            }}
            disabled={isLoading}
            startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
          >
            Read
          </Button>
        )}
      </div>
    );
  };

  const getmeetingbychp = async (ch_id) => {
    setMeetingData(await GetMeetingByChptId(ch_id));
  };

  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };

  const getMeetingFeedbackReportData = async () => {
    setIsLoading(true);
    let res = await getMeetingFeedbackReport();
    setIsLoading(false);
    if (res?.data?.length > 0) {
      setTableData(res?.data);
    } else {
      setTableData([]);
    }
  };

  useEffect(async () => {
    getallcitylist();
    getMeetingFeedbackForData();
    getMeetingFeedbackReportData();
  }, []);

  const [feedbackAttachmentDataModal, setFeedbackAttachmentDataModal] = useState(false);
  const [feedbackAttachmentList, setFeedbackAttachmentList] = useState([]);

  // Open modal with feedback ID
  const openModalWithAttachment = async (mf_id) => {
    setFeedbackAttachmentDataModal(true); // Open modal

    try {
      const resp = await getMemberFeedbackAttachment(mf_id);
      if (resp.status === 1) {
        setFeedbackAttachmentList(resp.data);
      } else {
        setFeedbackAttachmentList([]);
      }
    } catch (error) {
      console.error("Error fetching Attachment data:", error);
    }
  };

  // Close modal and reset state
  const closeModal = () => {
    setFeedbackAttachmentDataModal(false);
    setFeedbackAttachmentList([]);
  };

  return (
    <>
      <Page title="Meeting's Feeback Report | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Meeting's Feedback Report
            </Typography>
          </Stack>

          <Card className="p-20">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                        (loginUser?.u_type == 2 &&
                          loginUser?.p_user_id != 1 &&
                          loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        city_id: e.value,
                        chpt_id: 0,
                        meeting_id: 0
                      });
                    }}
                    value={
                      searchdata.city_id == 0
                        ? {
                          value: 0,
                          label: "All City"
                        }
                        : citylist.map((city) => {
                          return (
                            searchdata.city_id == city.city_id && {
                              value: city.city_id,
                              label: city.city_name
                            }
                          );
                        })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        chpt_id: e.value,
                        meeting_id: 0
                      });
                      getmeetingbychp(e.value);
                      getmemberbychp(e.value);
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchdata?.city_id != 0) {
                              if (searchdata?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchdata.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                        chaptlist.map((c) => {
                          if (c.chpt_id == searchdata.chpt_id) {
                            return {
                              value: c.chpt_id,
                              label: c.chpt_name
                            };
                          }
                        })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Meeting</label>
                  <Select
                    name="meeting_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, meeting_id: e.value });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Meeting"
                      },
                      ...meetingData.map((option) => {
                        return { value: option?.meeting_id, label: option?.date };
                      })
                    ]}
                    value={
                      searchdata.meeting_id == 0
                        ? {
                          value: 0,
                          label: "All Meeting"
                        }
                        : meetingData &&
                        meetingData.map((option) => {
                          if (searchdata.meeting_id == option.meeting_id) {
                            return {
                              value: option.meeting_id,
                              label: option.date
                            };
                          }
                        })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Member</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      searchdata.m_id == 0
                        ? {
                          value: 0,
                          label: "All Members"
                        }
                        : memberData.map((option) => {
                          return (
                            searchdata.m_id == option.m_id && {
                              value: option.value,
                              label: option.m_name
                            }
                          );
                        })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, m_id: e.value });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Members"
                      },
                      ...memberData
                        .map((option) => {
                          if (option.status == 1) {
                            return {
                              value: option.m_id,
                              label: option.m_name
                            };
                          }
                          return null;
                        })
                        .filter(Boolean)
                    ]}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Feedback Type</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      searchdata.feedbackFor == 0
                        ? {
                          value: 0,
                          label: "All "
                        }
                        : meetingFeedbackFor.map((option) => {
                          return (
                            searchdata.feedbackFor == option.m_f_id && {
                              value: option.m_f_id,
                              label: option.meeting_feedback_for
                            }
                          );
                        })
                    }
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        feedbackFor: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All"
                      },
                      ...meetingFeedbackFor.map((feedback) => {
                        return {
                          label: feedback?.meeting_feedback_for,
                          value: feedback?.m_f_id
                        };
                      })
                    ]}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Ratings</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={memberRatings.map((c) => {
                      if (c.value == searchdata.ratings) {
                        return { value: c.value, label: c.label };
                      }
                    })}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        ratings: e.value
                      });
                    }}
                    options={memberRatings}
                  />
                </Stack>
              </Grid>
              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Feedback Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={feedbackType.map((c) => {
                      if (c.value == searchdata.mf_read) {
                        return { value: c.value, label: c.label };
                      }
                    })}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        mf_read: e.value
                      });
                    }}
                    options={feedbackType}
                  />
                </Stack>
              </Grid>

              <Grid item xs={1} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>
          <Card style={{ marginTop: "15px" }}>
            {tableData && (
              <>
                <Button className="btn btn-export">
                  <CSVLink
                    data={newTableData}
                    headers={expo_columns}
                    filename={"Meeting Feedback Data.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={newTableData != null ? newTableData : []}
                  expandableRows
                  expandableRowsComponent={ExpandableRow}
                  expandableRowDisabled={(row) => !row?.mf_desc}
                  expandableRowExpanded={(row) => row?.mf_read == 0}
                  conditionalRowStyles={[
                    {
                      when: (row) => row?.mf_read === 1,
                      style: {
                        backgroundColor: "#e8f5e9" // green
                      }
                    },
                    {
                      when: (row) => row?.mf_read === 0,
                      style: {
                        backgroundColor: "#ffffff" // normal white
                      }
                    }
                  ]}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>

        <Modal
          open={feedbackAttachmentDataModal}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={feedbackAttachmentModalStyle}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginBottom: "5px", textAlign: "center" }}
            >
              Feedback Attachment
            </Typography>
            <hr />

            <Stack style={{ marginBottom: "10px", marginTop: "10px" }}>
              {feedbackAttachmentList.length > 0 ? (
                feedbackAttachmentList.map((attachment, index) => (
                  <Card key={index} sx={{ padding: "10px", marginBottom: "10px" }}>
                    <Typography variant="body1">
                      <a
                        href={`${Routes.API_HOSTNAME}images/feedback_attachement/${attachment.media}`} // Assuming the API provides a file URL
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "blue" }}
                      >
                        {attachment.media.split("_").slice(1).join("_") ||
                          `Attachment ${index + 1}`}
                      </a>
                    </Typography>
                  </Card>
                ))
              ) : (
                <Typography variant="body2" style={{ textAlign: "center" }}>
                  No attachments available
                </Typography>
              )}
            </Stack>
            <hr />
            <div
              style={{
                margin: "10px  auto 0",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={closeModal}
                style={{ marginTop: "0px", marginRight: "0px" }}
              >
                Close
              </Button>
            </div>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
